import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const SelectPvSystemsForRedesignTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SELECT_PV_SYSTEMS_FOR_REDESIGN),
  selections: z.array(z.object({ pvSystemId: z.string(), bidRequestId: z.string() })).min(1),
});
